import { useContext, useEffect, useRef } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { UserContext } from "../UserContext";
import useTokenGeneration from "../../hooks/useToken.hook";
import { ACTIVITY_STORAGE_KEY, HOME_URL } from "../../utlities/core.constants";

function Callback() {
  const { setJwt } = useContext(UserContext);
  const navigate = useNavigate();
  const [searchParams, ] = useSearchParams();
  const { generateToken, postOAuthToken } = useTokenGeneration();
  const processedCodeRef = useRef(null);

  useEffect(() => {
    if(!searchParams.has('code')){
      return;
    }

    (async () => {
      const code = searchParams.get('code');
      if (!code || processedCodeRef.current === code) {
        return;
      }
      processedCodeRef.current = code;

      try {
        const jwt = await generateToken();
        const { data } = await postOAuthToken(code, jwt);

        setJwt(data);

        if(!data || !data.id_token){
          return;
        }

        try {
          localStorage.setItem(ACTIVITY_STORAGE_KEY, Date.now().toString());
        } catch { /* localStorage may be unavailable */ }

        const rawState = searchParams.get("state");
        let returnPath = null;

        if (rawState) {
          try {
            const decodedState = decodeURIComponent(rawState).replace(/=+$/g, "");
            if (decodedState.startsWith("/") && !decodedState.startsWith("//")) {
              returnPath = decodedState;
            }
          } catch {
            // Ignore invalid state value and fall back.
          }
        }

        navigate(returnPath || HOME_URL);
      } catch {
        // Allow retry if exchange failed for any reason.
        processedCodeRef.current = null;
      }
    })();
  }, [generateToken, navigate, postOAuthToken, searchParams, setJwt])

  return null;

}

export default Callback;
